// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"9febc41b","397":"9febc41b","429":"b09e505e","751":"99d8650d","752":"baf6b4d5","874":"baf6b4d5"}[chunkId] + ".chunk.css";
};